import { ObjectReference } from '@totem/components/administration/reconciliation/nozomi/types';

// A sensor's asset count read straight from Vantage by the asset count job.
export type ApiSiteAssetCount = {
  siteId: string;
  apiConnectionId: string;
  source: string;
  siteName: string;
  countedAt: string; // last successful count
  lastAttemptAt: string;
  durationSeconds: number;
  success: boolean; // whether the last attempt succeeded
  error: string;

  total: number;
  active24h: number;
  active7d: number;
  active30d: number;

  it: number;
  ot: number;
  iot: number;
  otherCategory: number;

  noMac: number;
  localMacOnly: number;
};

export type NozomiVantageSensorAssetCount = {
  siteId: string;
  siteName: string;
  displayName: string;
  status: string;
  organization: ObjectReference;
  building: ObjectReference;
  mapped: boolean;
  count: ApiSiteAssetCount | null;
};

export type NozomiVantageAssetCounts = {
  generatedAt: string;
  sensors: NozomiVantageSensorAssetCount[];
};

// Key for a refresh of every sensor, alongside per-sensor refreshes keyed by site id.
export const ALL_SENSORS = 'all';

export type RefreshStatus = 'pending' | 'running';

export type AssetCountTotals = {
  total: number;
  active24h: number;
  active7d: number;
  active30d: number;
  it: number;
  ot: number;
  iot: number;
  otherCategory: number;
  noMac: number;
  localMacOnly: number;
  counted: number; // sensors with a successful count
};

export type AssetCountRow = AssetCountTotals & {
  key: string;
  kind: 'organization' | 'sensor';
  name: string;
  siteId?: string;
  building?: string;
  mapped?: boolean;
  count?: ApiSiteAssetCount | null;
  sensorCount?: number;
  children?: AssetCountRow[];
};
